import {
	Component,
	OnInit,
	forwardRef,
	ViewEncapsulation,
	ElementRef,
	ChangeDetectorRef
} from '@angular/core';
import { DaterangepickerComponent } from 'ngx-daterangepicker-material';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SettingsProvider } from '../../../../../shared/services/settings/settings';

import moment = require('moment');

@Component({
	selector: 'sn-date-range-picker',
	template: require('./sn-date-range-picker.component.html'),
	styles: [require('./sn-date-range-picker.component.scss')],
	host: {
		'(click)': 'handleInternalClick($event)'
	},
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => DaterangepickerComponent),
			multi: true
		}
	]
})
export class SnDateRangePickerComponent extends DaterangepickerComponent
	implements OnInit {
	currentStart;
	currentEnd;
	pickerInputFormat: string;
	calendarInputsFormat: string;

	constructor(
		private snEl: ElementRef,
		private _snRef: ChangeDetectorRef,
		private settingsService: SettingsProvider
	) {
		super(snEl, _snRef);
	}

	ngOnInit() {
		super.ngOnInit();
		this.setDateFormatting();
		this.locale.separator = ' ➔ ';
		this.locale.format = 'YYYY-MM-DD';
		this.locale.applyLabel = 'Apply Dates';
	}

	setCurrentStart(v) {
		this.currentStart = v.target.value;
	}

	setCurrentEnd(v) {
		this.currentEnd = v.target.value;
	}

	changeStart(v): void {
		const newValue = this.convertToAcceptedFormat(v.target.value);
		const parsed = moment(newValue, this.locale.format, true);
		if (parsed.isValid()) {
			this.endDate = null;
			this.setStartDate(newValue);
			this.updateView();
		} else {
			const startDateInput: HTMLInputElement = document.getElementById(
				'startDateInput'
			) as HTMLInputElement;
			startDateInput.value = this.currentStart;
		}
	}

	changeEnd(v): void {
		const newValue = this.convertToAcceptedFormat(v.target.value);
		const parsed = moment(newValue, this.locale.format, true);
		if (parsed.isValid()) {
			this.setEndDate(newValue);
			this.updateView();
		} else {
			const endDateInput: HTMLInputElement = document.getElementById(
				'endDateInput'
			) as HTMLInputElement;
			endDateInput.value = this.currentEnd;
		}
	}

	convertToAcceptedFormat(date: string): string {
		if (this.calendarInputsFormat === 'dd/MM/yyyy') {
			return date
				.split('/')
				.reverse()
				.join('-');
		}
		return date.replace(/(\d\d)\/(\d\d)\/(\d{4})/, '$3-$1-$2');
	}

	updateElement(): void {
		if (!this.singleDatePicker && this.autoUpdateInput) {
			if (this.startDate && this.endDate) {
				// if we use ranges and should show range label on inpu
				if (
					this.rangesArray.length &&
					this.showRangeLabelOnInput === true &&
					this.chosenRange &&
					this.locale.customRangeLabel !== this.chosenRange
				) {
					this.chosenLabel = this.chosenRange;
				} else {
					this.chosenLabel =
						this.startDate.format(this.pickerInputFormat) +
						this.locale.separator +
						this.endDate.format(this.pickerInputFormat);
				}
			}
		} else if (this.autoUpdateInput) {
			this.chosenLabel = this.startDate.format(this.pickerInputFormat);
		}
	}

	setDateFormatting(): void {
		this.settingsService.timeFormatSettings.subscribe(data => {
			this.pickerInputFormat =
				data.dateFormat === 'DD_MM_YYYY' ? 'DD MMM YYYY' : 'MMM DD YYYY';
			this.calendarInputsFormat =
				data.dateFormat === 'DD_MM_YYYY' ? 'dd/MM/yyyy' : 'MM/dd/yyyy';

			switch (data.weekStartsOn) {
				case 'SATURDAY':
					this.locale.daysOfWeek = ['S', 'S', 'M', 'T', 'W', 'T', 'F'];
					this.locale.firstDay = -1;
					break;
				case 'SUNDAY':
					this.locale.daysOfWeek = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
					this.locale.firstDay = 0;
					break;
				default:
					this.locale.daysOfWeek = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
					this.locale.firstDay = 1;
					break;
			}
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/common/sn-date-range-picker/sn-date-range-picker.component.ts